import React from 'react';
import { Link } from 'react-router';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as SVGICONS from '../../images/img/images';
import { ToastContainer, toast } from 'react-toastify';
import toastr from 'toastr';

import * as appointmentActions from '../../actions/appointmentActions';
import moment from 'moment';
// import momentzone from 'moment-timezone'
// import StarRatingComponent from 'react-star-rating-component';
import {
	Modal,

} from 'react-bootstrap'
import classNames from 'classnames';
import validator from '../common/validator';
import Moment from 'react-moment';

const autoBind = require('auto-bind');
const style = {
	// textAlign: 'center',
	fontWeight: 600,
	fontSize: 15
}

class FeedbackRemainder extends React.Component {

	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
		};
		this.dontRemindAgain = this.dontRemindAgain.bind();
		//binding current context to all functions
	}

	componentWillReceiveProps(nextProps) {

	}
	componentWillMount() {

	}
	dontRemindAgain() {
		var obj = {
			patientId: localStorage.getItem('userId'),
			appointmentId: this.props.appointmentId
		}
		this.props.actions.dontRemindAgain(obj);
		this.props.closeModal();
	}
	feedbackRemindLater() {
		// localStorage.setItem('feedbackRemind', false);+
	var	toastId = null;
	var	customToastId = 'xxx-yyy';
		var obj = {
			patientId: localStorage.getItem('userId'),
			appointmentId: this.props.appointmentId
		}
		this.props.actions.remindLatter(obj);
		//  toast.success('Successfully marked remind later');





		this.props.closeModal();
	}

	Capitalize(str) {
		if (str != '' && str != undefined)
			return str.charAt(0).toUpperCase() + str.slice(1);
		else
			return '';
	}


	render() {
		return (
			<Modal show={this.props.isOpenModal} size="modal-sm" onHide={this.props.nextRateReminderModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.nextRateReminderModal} /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form" id="loginForm" >
						<div style={style}>
							<p>Rate your consultation with Dr.<span className="text-capitalize">{this.Capitalize(this.props.doctorName)}</span></p>
							<div className="row" style={{ fontSize: 14 }}>
								<div className="col-sm-8 appDateInfo">
									<span>Appointment Date:

											{this.props.appointmentDate ? ' '+moment(this.props.appointmentDate).format('DD-MM-YYYY') : ''}

									</span>
								</div>
								<div className="col-sm-4" ><span>Time:<span className="appTimeInfo">{this.props.appointmentDate ? moment(this.props.appointmentDate).format('h:mm A') : ''}</span></span></div>
							</div>
							<div className="row" style={{ marginTop: 33, }}>
								<div className="col-sm-6">
									<button type="button" onClick={this.props.openRateCloseRemainder} className="btn btn-block btn-warning">
										<span>Yes</span>
									</button>
								</div>
								<div className="col-sm-6" >
									<button type="button" className="btn btn-block btn-warning btn-remind-later" onClick={this.feedbackRemindLater}>
										<span>Remind later</span>
									</button>
								</div>
							</div>
							<div className="row" style={{
								marginTop: 28
							}}>
								<div className="col-sm-12" >
									<input className="feedbackPopupcheckbox" type="checkbox" onChange={this.dontRemindAgain} />
									<label htmlFor="monday" className="startReview" style={{ margin: 0 }}>
										<span style={{
											fontSize: 14, fontWeight: 400, display: 'inline-block'
										}}>Do not remind me again</span> </label>
								</div>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(FeedbackRemainder);
// export default (FeedbackRemainder);
